import React, { useEffect, useState } from "react";
import { Dropdown, Modal, Nav, Tab } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  get_Gemstone_Category_data,
  get_Gemstone_CategorySingledata,
} from "../../../store/actions/CommanAction";
import swal from "sweetalert";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import DataTable from "react-data-table-component";
import { customStyles } from "../Utility/Utility";
import Loader from "../Loader/Loader";

const GemstoneCategory = () => {
  const dispatch = useDispatch();
  const GemstoneCategorydata = useSelector(
    (state) => state.feedBackReducer.GemstoneCategorydata
  );
  const GemstoneCategorySingledata = useSelector(
    (state) => state.feedBackReducer.GemstoneCategorySingledata
  );
  const customerID = Number(sessionStorage.getItem("ID"));

  const [IsActive, setIsActive] = useState(true);
  const [postModal, setPostModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [EditValue, setEditValue] = useState("");
  const [GemstoneCategoryID, setGemstoneCategoryID] = useState("");
  const [loading, setloading] = useState(false);

  const [addFormData, setaddFormData] = useState({
    Category: "",
    Logo: null,
    CreatedByUser: "1",
    IsActive: "1",
  });

  const Reset = () => {
    setaddFormData({ ...addFormData, Category: "",Logo: null});
  };

  useEffect(() => {
    if (GemstoneCategorySingledata) {
      setEditValue(GemstoneCategorySingledata);
    }
  }, [GemstoneCategorySingledata]);

  useEffect(() => {
    if (IsActive) {
      dispatch(get_Gemstone_Category_data("1", setloading));
    } else {
      dispatch(get_Gemstone_Category_data("0", setloading));
    }
  }, [IsActive, IsActive]);

  useEffect(() => {
   
    if (EditValue && EditValue.length > 0) {
      setaddFormData({
        ...addFormData,
        GemstoneCategoryID: GemstoneCategoryID,
        Category: EditValue[0]?.Category,
        ModifiedByUser: "1",
        Logo:EditValue[0]?.Icon
      });
    }
  }, [EditValue]);

  

const handleAddFormSubmit = async (event) => {
  event.preventDefault();

  let error = false;
  let errorMsg = "";

  if (!addFormData.Category || addFormData.Category.trim() === "") {
    error = true;
    errorMsg = "Please fill Category.";
  }

  if (!error) {
    const formData = new FormData();

    const newCustomerStory = {
      Category: addFormData.Category,
      IsActive: addFormData.IsActive,
    };

    formData.append("Data", JSON.stringify(newCustomerStory));
    formData.append("File", addFormData.Logo);

    try {
      const res = await AddUpdate("GemstoneCategory/Insert_GemstoneCategory", formData);

    
      const parsed = JSON.parse(res?.data?.data); 

      const message = parsed?.Table?.[0]?.Message;

      if (message === "Not Insert Successfully ") {
        swal("Oops!", "Duplicate entry. This category already exists.", "error");
      } else {
        setPostModal(false);
        dispatch(get_Gemstone_Category_data(IsActive, setloading));
        swal("Good job!", "Successfully Added", "success");

        Reset();
        setaddFormData({ Category: "", Logo: null, IsActive: true });
      }
    } catch (err) {
      console.error("Error:", err);
      swal("Oops", "Failed to add category", "error");
    }
  } else {
    swal("Oops", errorMsg, "error");
  }
};

const UpdateSlider = async (event) => {
  event.preventDefault();
  let error = false;
  let errorMsg = "";
  if (addFormData.Category === "") {
    error = true;
    errorMsg = "Please fill Category.";
  }
  if (!error) {
    const formData = new FormData();
    // Prepare data to send
    const dataToSend = { ...addFormData };
    if (addFormData.Logo && typeof addFormData.Logo === "string") {
      dataToSend.ExistingLogo = addFormData.Logo;
    }
    formData.append("Data", JSON.stringify(dataToSend));
  
    if (addFormData.Logo && typeof addFormData.Logo !== "string") {
      formData.append("File", addFormData.Logo);
    }
    await AddUpdate("GemstoneCategory/UpDate_GemstoneCategry", formData);
    setEditModal(false);
    dispatch(get_Gemstone_Category_data(IsActive, setloading));
    swal("Good job!", "Successfully update", "success");
    Reset();
    setaddFormData({ Category: "" });
  } else {
   
    swal("Oops", errorMsg, "error");
  }
};

  const handleAddFormChange = (e) => {
    setaddFormData({ ...addFormData, [e.target.name]: e.target.value });
  };

  const handleEditClick = (row) => {
    dispatch(get_Gemstone_CategorySingledata(row?.GemstoneCategoryID));
    setGemstoneCategoryID(row?.GemstoneCategoryID);
    setEditModal(true);
  };

  const columns = [
    {
      name: "Category",
      selector: (row) => row.Category,
      sortable: true,
    },
    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 50 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <div style={{ position: "absolute", top: 4, right: 50 }}>
          <Dropdown>
            <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
              <Dropdown.Item onClick={() => handleEditClick(row)}>
                Edit
              </Dropdown.Item>
              <Dropdown.Item
                className={row.IsActive ? "text-danger" : "text-success"}
                onClick={() => {
                  handleToggleStatusClick(row.GemstoneCategoryID, true, "0");
                }}
              >
                Inactive
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
  ];

  const columns1 = [
    {
      name: "Category",
      selector: (row) => row.Category,
      sortable: true,
    },
    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 0 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <>
          <div style={{ position: "absolute", top: 4, right: 5 }}>
            <Dropdown>
              <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                <Dropdown.Item
                  className={row.IsActive ? "text-danger" : "text-success"}
                  onClick={() => {
                    handleToggleStatusClick(row.GemstoneCategoryID, false, "1");
                  }}
                >
                  Active
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </>
      ),
    },
  ];

  const handleToggleStatusClick = async (
    GemstoneCategoryID,
    currentStatus,
    isActiveValue
  ) => {
    const postData = {
      GemstoneCategoryID: GemstoneCategoryID,
      DeleteByUser: customerID,
      IsActive: isActiveValue,
    };
    await AddUpdate("GemstoneCategory/Delete_GemstoneCategory", postData);
    dispatch(get_Gemstone_Category_data(currentStatus ? "1" : "0", setloading));
    swal(
      "Good job!",
      `Successfully ${isActiveValue === "1" ? "Active" : "Inactive"}`,
      "success"
    );
  };
  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setaddFormData((prev) => ({
        ...prev,
        Logo: file,
      }));
    }
  };

  return (
    <>
   
     <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Gemstone Category</h2>
      <Tab.Container defaultActiveKey="All">
        <div className="mt-2 d-flex justify-content-between align-items-center flex-wrap main_card  mb-1">
          <div className="card-action coin-tabs mb-2">
            <Nav as="ul" className="nav nav-tabs" role="tablist">
              <Nav.Item as="li" className="nav-item">
                <Nav.Link
                  className="nav-link"
                  eventKey="All"
                  onClick={(currentStatus) => {
                    setIsActive(true);
                  }}
                >
                  Active
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li" className="nav-item">
                <Nav.Link
                  className="nav-link"
                  eventKey="Inactive"
                  onClick={(currentStatus) => {
                    setIsActive(false);
                  }}
                >
                  Inactive
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          <div className="" >
      <Link
        to={"#"}
        className="btn btn-primary font-w600  me-auto"
        onClick={() => {
          setPostModal(true);
          Reset();
        }}
      >
        + New Categorys
      </Link>
      </div>

        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="">
              <div className=" p-0">
                <Tab.Content>
                  <Tab.Pane eventKey="All">
                    <div className="mb-sm-3 d-flex flex-wrap align-items-center text-head">
                      <Modal
                        className="modal fade"
                        show={postModal}
                        onHide={() => setPostModal(false)}
                        backdrop="static"
                      >
                        <form>
                          <div className="modal-header">
                            <h4 className="modal-title fs-20">Add Categorys</h4>
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => setPostModal(false)}
                              data-dismiss="modal"
                            ></button>
                          </div>
                          <div className="modal-body p-3">
                            <i
                              className="flaticon-cancel-12 close"
                              data-dismiss="modal"
                            ></i>
                            <div className="add-contact-box">
                              <div className="add-contact-content">
                                <div className="form-group">
                                <label htmlFor="">Categorys</label>
                                <span className="text-danger star-error">
                                  *
                                </span>
                                <input
                                  type="text"
                                  // className="form-control"
                                  autoComplete="off"
                                  name="Category"
                                  required="required"
                                  value={addFormData?.Category}
                                  onChange={handleAddFormChange}
                                />
                                </div>
                              </div>
                            </div>

                            <div className="add-contact-box mt-3">
                              <div className="add-contact-content">
                                <div className="form-group">
                                <label htmlFor="">Logo</label>
                                {addFormData.Logo && typeof addFormData.Logo === "string" && (
                                  <img
                                    src={`https://${addFormData.Logo.replace(/\\/g, "/")}`}
                                    alt="Current Logo"
                                    style={{ width: 80, marginBottom: 8 }}
                                  />
                                )}
                                {addFormData.Logo && typeof addFormData.Logo !== "string" && (
                                  <img
                                    src={URL.createObjectURL(addFormData.Logo)}
                                    alt="New Logo Preview"
                                    style={{ width: 80, marginBottom: 8 }}
                                  />
                                )}
                                <input
                                  type="file"
                                  // className="form-control"
                                  name="Logo"
                                  accept=".apng,.png,.jpg,.jpeg,.jfif,.pjpeg,.pjp"
                                  onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (!file) {
                                      return;
                                    } else {
                                      setaddFormData((prev) => ({
                                        ...prev,
                                        Logo: file,
                                      }));
                                    }
                                  }}
                                />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="submit"
                              className="btn btn-primary"
                              onClick={handleAddFormSubmit}
                            >
                              Save
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                setPostModal(false);
                                Reset();
                              }}
                              className="btn btn-danger"
                            >
                              <i className="flaticon-delete-1"></i> Close
                            </button>
                          </div>
                        </form>
                      </Modal>
                    </div>
                    <Modal
                      className="modal fade "
                      show={editModal}
                      onHide={setEditModal}
                      backdrop="static"
                    >
                      <div className="" role="document">
                        <div className="">
                          <form>
                            <div className="modal-header">
                              <h4 className="modal-title fs-20">
                                Edit Categorys
                              </h4>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={() => setEditModal(false)}
                                data-dismiss="modal"
                              ></button>
                            </div>
                            <div className="modal-body p-3">
                              <i
                                className="flaticon-cancel-12 close"
                                data-dismiss="modal"
                              ></i>
                              <div className="add-contact-box">
                              <div className="add-contact-content">
                              <div className="form-group">
                                <label htmlFor="">Categorys</label>
                                <span className="text-danger star-error">
                                  *
                                </span>
                            
                                <input
                                  type="text"
                                  // className="form-control"
                                  autoComplete="off"
                                  name="Category"
                                  required="required"
                                  value={addFormData?.Category}
                                  onChange={handleAddFormChange}
                                />
                                </div>
                              </div>
                            </div>

                            <div className="add-contact-box mt-3">
                              <div className="add-contact-content">
                                <label htmlFor="">Logo</label>
                                {addFormData.Logo && typeof addFormData.Logo === "string" && (
                                  <img
                                    src={`https://${addFormData.Logo.replace(/\\/g, "/")}`}
                                    alt="Current Logo"
                                    style={{ width: 80, marginBottom: 8 }}
                                  />
                                )}
                                {addFormData.Logo && typeof addFormData.Logo !== "string" && (
                                  <img
                                    src={URL.createObjectURL(addFormData.Logo)}
                                    alt="New Logo Preview"
                                    style={{ width: 80, marginBottom: 8 }}
                                  />
                                )}
                                <div className="form-group">
                                <input
                                  type="file"
                                  // className="form-control"
                                  name="Logo"
                                  accept=".apng,.png,.jpg,.jpeg,.jfif,.pjpeg,.pjp"
                                  onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (!file) {
                                      return;
                                    } else {
                                      setaddFormData((prev) => ({
                                        ...prev,
                                        Logo: file,
                                      }));
                                    }
                                  }}
                                />
                                </div>
                              </div>
                            </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="submit"
                                className="btn btn-primary"
                                onClick={UpdateSlider}
                              >
                                Update
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  setEditModal(false);
                                  Reset();
                                }}
                                className="btn btn-danger"
                              >
                                {" "}
                                <i className="flaticon-delete-1"></i> Close
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </Modal>
                    <div className="col-12 mt-2">
                      {loading ? (
                        <Loader />
                      ) : (
                        <DataTable
                          dense
                          data={GemstoneCategorydata}
                          columns={columns}
                          selectableRowsHighlight
                          pagination
                          persistTableHead={true}
                          noDataComponent={"There are no data to display"}
                          customStyles={customStyles}
                        />
                      )}
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="Inactive">
                    <div className="row">
                      <div className="col-12 mt-2">
                        {loading ? (
                          <Loader />
                        ) : (
                          <DataTable
                            dense
                            data={GemstoneCategorydata}
                            columns={columns1}
                            selectableRowsHighlight
                            highlightOnHover
                            pagination
                            fixedHeader
                            persistTableHead={true}
                            noDataComponent={"There are no data to display"}
                          />
                        )}
                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </div>
        </div>
      </Tab.Container>
    
    </>
  );
};
export default GemstoneCategory;



